<template>
  <page :title="$tc('subscriptions.orders')">
    <div slot="page-header-right">
      <a :href="fullUrl" target="_blank" class="button">
        <b-icon icon="download"></b-icon>
        <span>{{ $tc('download.verb') }}</span>
      </a>
    </div>

    <div class="box">
      <filters @input="value => orders.filter(value).load()"></filters>

      <div class="tabs">
        <ul>
          <li :class="{'is-active': tab == 'all'}"><a @click="tab = 'all'">{{$tc('pay.all')}}</a></li>
          <li :class="{'is-active': tab == 'paid'}"><a @click="tab = 'paid'">{{$tc('pay.paid')}}</a></li>
          <li :class="{'is-active': tab == 'created'}"><a @click="tab = 'created'">{{$tc('pay.unpaid')}}</a></li>
          <li :class="{'is-active': tab == 'canceled'}"><a @click="tab = 'canceled'">{{$tc('pay.cancel')}}</a></li>
          <li :class="{'is-active': tab == 'test'}"><a @click="tab = 'test'">{{$tc('pay.test')}}</a></li>
        </ul>
      </div>

      <b-table
        :data="orders.data"
        :loading="orders.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="orders.current_page"
        :per-page="orders.per_page"
        :total="orders.total"
        @page-change="page => orders.changePage(page)"
        backend-sorting
        @sort="(field, direction) => orders.sort(field, direction)"
        :default-sort="['id', 'desc']"
        class="is-middle"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="#" sortable width="80">
            <router-link :to="`/orders/${props.row.id}`">
              <span class="has-text-primary" v-if="props.row.id">{{ props.row.id }}</span>
            </router-link>

          </b-table-column>

          <b-table-column label="User">
            <router-link :to="'/users/' + props.row.user.id">
              <span class="has-text-black" v-if="props.row.user.email">{{ props.row.user.email }}</span>
              <span class="has-text-grey" v-else>User {{ props.row.user.id }}</span>
            </router-link>

            <div class="has-text-grey is-size-7">{{ props.row.user.name }}</div>
          </b-table-column>

          <b-table-column label="State">
            <span class="tag" :class="{'is-success': props.row.state == 'paid'}">{{ props.row.state }}</span>
          </b-table-column>

          <b-table-column label="Price" sortable field="total_price">
            <span class="has-text-grey">{{ props.row.currency_code }} {{ props.row.total_price }}</span>
          </b-table-column>

          <b-table-column>
            <span v-if="props.row.is_test" class="tag is-warning">Test</span>
          </b-table-column>

          <b-table-column label="Payment">
            <span v-if="props.row.state == 'paid'" class="has-text-grey truncate">
              {{ props.row.payment_gateway }} /
              <b-tooltip label="Payment Transaction Id">{{ props.row.payment_transaction_id }}</b-tooltip>
            </span>
          </b-table-column>

          <b-table-column label="Payment type" width="100">
            <span v-if="props.row.payment_type == 'gift'" class="tag is-info"> {{ props.row.payment_type }}</span>
            <span v-if="props.row.payment_type == 'web'" class="tag is-warning"> {{ props.row.payment_type }}</span>
            <span v-else class="tag is-primary"> {{ props.row.payment_type }}</span>

          </b-table-column>

          <b-table-column label="Created At" field="created_at" sortable>
            <b-tooltip
              class="has-text-grey"
              :label="props.row.created_at | dateTime"
            >{{ props.row.created_at | date }}</b-tooltip>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>{{$tc('Nothinghere')}}</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
import Filters from "./Filters";
import querystring from "querystring";

export default {
  components: {
    Filters
  },

  data() {
    return {
      tab: 'paid',
      orders: new window.PaginatedRemoteCollection(
        "/admin/api/orders"
      )
    };
  },

  computed: {
    fullUrl() {
      let query = this.orders.requestParams();

      query.format = "xlsx";

      return this.orders.resolveUrl() + "?" + querystring.stringify(query);
    },

    filters() {
      if (this.tab == 'paid' || this.tab == 'canceled' || this.tab == 'created') {
        return {
          state: this.tab,
          test: 0
        }
      }

      if (this.tab == 'test') {
        return {
          test: 1
        }
      }

      return {
        test: 0
      };
    }
  },

  watch: {
    tab() {
      this.load();
    }
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      this.orders.filter(this.filters, true).load();
    }
  }
};
</script>
